export default __webpack_public_path__ + "static/media/NSECORPCERT.c582cef8.png";